import _ from "lodash"

export default function(input) {
  // Important condition for undefined input
  if (!input) return true

  let pristine = true

  Object.keys(input)
    .filter(x => !x.startsWith("_"))
    .forEach(key => {
      const val = input[key]

      if (_.isArray(val)) {
        val.forEach(ival => {
          if (_.some(ival, "touched")) pristine = false
        })
      } else if (_.some(val, "touched")) pristine = false
    })

  return pristine
}
